// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manufacturer } from './manufacturer';
import { SupplierImage } from './supplier-image';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  apiLink?: string;
  /** Boolean */
  isPrimary!: boolean;
  /** Boolean */
  isThumbnail!: boolean;
  /** Guid FK manufacturer */
  manufacturerId!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplierImage */
  supplierImageId!: string;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** FK supplierImageId */
  supplierImage!: SupplierImage;
}

